import { hostsAtom } from "@sunrise/http-client";
import { type Nullable } from "@sunrise/utils";
import { atomWithSuspenseQuery } from "jotai-tanstack-query";
import { atomFamily } from "jotai/utils";
import { isNil } from "lodash";

import { fetchAsset } from "./asset.service";
import type { AssetId } from "@sunrise/backend-types-core";
import { queryKeys, type Asset } from "@sunrise/backend-types";

export const assetDetailsByIdAtom = atomFamily((assetId: Nullable<AssetId>) =>
  atomWithSuspenseQuery<Nullable<Asset>>((get) => {
    const host = get(hostsAtom).data;
    if (isNil(host)) throw new Error("Host is not set");

    return {
      enabled: !isNil(assetId),
      queryKey: queryKeys.assetById(assetId),
      queryFn: async () => {
        if (!assetId) return null;
        return fetchAsset(host, assetId);
      },
      staleTime: Infinity,
      cacheTime: Infinity,
    };
  }),
);
